import { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import type { Test } from '@bugbug/core/types/tests';
import toasts from '~/services/toasts';
import { ACTIONS } from '~/services/toasts/internalServerError';

import { testsApi } from '../../tests.api';
import { showTestError } from '../../tests.utils';

export const useUpdateTest = () => {
  const { t } = useTranslation(undefined, { keyPrefix: 'useUpdateTest' });
  const [updateTest, updateTestRequest] = testsApi.useUpdateTestMutation();

  const handleUpdateTest = useCallback(
    async (id: Test['id'], params: Partial<Test>) => {
      const result = updateTest({
        id,
        data: params,
      }).unwrap();

      result
        .then(() => {
          toasts.showSuccess({
            content: t('updateSuccessInfo', 'Test has been updated successfully.'),
          });
        })
        .catch((error) => {
          showTestError(ACTIONS.UPDATE, error as Error);
        });

      return result;
    },
    [updateTest, t],
  );

  return useMemo(
    () => [handleUpdateTest, updateTestRequest] as const,
    [handleUpdateTest, updateTestRequest],
  );
};
